import CryptoJS from 'crypto-js'

// Configuration for encryption - you can move this to your config file
export const Config = {
  ENC_KEY: process.env.REACT_APP_ENC_KEY || '9Ddyaf6rfywpiTvTiax2iq6ykKpaxgJ6',
  ENC_IV: process.env.REACT_APP_ENC_IV || '9Ddyaf6rfywpiTvT'
}

/**
 * Encrypts data using AES encryption
 * @param data - Data to encrypt (will be JSON stringified)
 * @returns Encrypted string
 */
export const getEncryptedText = (data: any): string => {
  try {
    const truncHexKey = CryptoJS.SHA256(Config.ENC_KEY).toString().substr(0, 32)
    const key = CryptoJS.enc.Utf8.parse(truncHexKey)
    const iv = CryptoJS.enc.Utf8.parse(Config.ENC_IV)

    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    })

    return ciphertext.toString()
  } catch (error) {
    console.error('Encryption failed:', error)
    throw new Error('Failed to encrypt data')
  }
}

/**
 * Decrypts encrypted data
 * @param cipher - Encrypted string to decrypt
 * @returns Decrypted and parsed data
 */
export const getDecryptedData = (cipher: string): any => {
  try {
    const truncHexKey = CryptoJS.SHA256(Config.ENC_KEY).toString().substr(0, 32)
    const key = CryptoJS.enc.Utf8.parse(truncHexKey)
    const iv = CryptoJS.enc.Utf8.parse(Config.ENC_IV)

    const decryptedData = CryptoJS.AES.decrypt(cipher, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    })

    return JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8))
  } catch (error) {
    console.error('Decryption failed:', error)
    throw new Error('Failed to decrypt data')
  }
}

/**
 * Validates if a string appears to be encrypted (base64 format)
 * @param str - String to validate
 * @returns true if string appears to be encrypted
 */
export const isEncryptedString = (str: string): boolean => {
  if (!str || typeof str !== 'string') return false
  
  // Basic check for base64 format (AES encrypted output)
  const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/
  return base64Regex.test(str) && str.length > 20 // Encrypted strings are typically longer
} 